module.exports = __webpack_public_path__ + "static/img/paypal-6.966c297.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/help/paypal-6.png
// module id = oDUo
// module chunks = 1